import { styled } from '@linaria/react'
import { MEDIA } from 'vars/index'
import { EpgPlayerAspectRatio } from './EpgHeadPlayer.h'

export const EpgHeadSC = styled.div`
  --widthPlayerFullHDResolution: 554px;
  --widthPlayerHDResolution: 432px;

  position: relative;
  /* Mobile / tablet - fill the width of the container */
  width: 100%;
  aspect-ratio: ${EpgPlayerAspectRatio.DEFAULT};
  overflow: hidden;

  ${MEDIA.MIN_768} {
    width: var(--widthPlayerHDResolution);
  }

  ${MEDIA.MIN_1920} {
    width: var(--widthPlayerFullHDResolution);
  }

  /* Pin the player inside this box so it cannot stretch the height (aspect-ratio priority)*/
  & > * {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`
